import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { UiIconModule } from "../icon/icon.module";
import { UiSelectModule } from "../select/select.module";
import { UiPaginationDefaultComponent } from "./components/pagination-default/pagination-default.component";
import { UiPaginationItemComponent } from "./components/pagination-item/pagination-item.component";
import { UiPaginationOptionsComponent } from "./components/pagination-options/pagination-options.component";
import { UiPaginationSimpleComponent } from "./components/pagination-simple/pagination-simple.component";
import { UiPaginationComponent } from "./pagination.component";

@NgModule({
  imports: [CommonModule, FormsModule, UiSelectModule, UiIconModule],
  declarations: [UiPaginationComponent, UiPaginationDefaultComponent, UiPaginationItemComponent, UiPaginationOptionsComponent, UiPaginationSimpleComponent],
  exports: [UiPaginationComponent],
})
export class UiPaginationModule {}
